import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchLeadFormThunk, fetchOutdoorBarArticleCategoriesThunk } from 'shared/lib';
import { OutdoorBarArticlesPageState } from './state';
import { GetOutdoorBarsServiceActionResponseMapper, OutdoorBarsPageActions } from './actions';
import BaseError from '../../../utils/base-error';
import {
    createOutdoorBarArticleCardsFromGetOutdoorBarArticlesByCategoryUidApiResponse,
    createOutdoorBarArticleCategoriesFromGetOutdoorBarArticleCategoriesApiResponse,
} from '../utils';

const initialState: OutdoorBarArticlesPageState = {
    loaded: false,
    errors: [],
    outdoorBarArticleCategories: [],
    outdoorBarArticleCards: [],

    title: 'Выездные бары',
    image: {
        url: '', // TODO
    },
};

export const outdoorBarsPageSlice = createSlice({
    name: 'outdoorBarsPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        /**
         * Обработчик получения списка типов баров (коллекция outdoorBarArticleCategory)
         */
        builder.addCase(
            fetchOutdoorBarArticleCategoriesThunk.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createOutdoorBarArticleCategoriesFromGetOutdoorBarArticleCategoriesApiResponse(
                            response.data,
                        );

                        state.outdoorBarArticleCategories = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        /**
         * Обработчик получения списка карточек выездных баров по типу (коллекция OutdoorBarArticle)
         */
        builder.addCase(
            OutdoorBarsPageActions.getOutdoorBarArticleCardsByCategoryUid.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createOutdoorBarArticleCardsFromGetOutdoorBarArticlesByCategoryUidApiResponse(
                            response.data,
                        );
                        state.outdoorBarArticleCards = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            OutdoorBarsPageActions.getOutdoorBarsService.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        state.title = GetOutdoorBarsServiceActionResponseMapper.getTitle(
                            response,
                        );
                        state.description = GetOutdoorBarsServiceActionResponseMapper
                            .getDescription(
                                response,
                            );
                        state.image = GetOutdoorBarsServiceActionResponseMapper.getImage(
                            response,
                        );
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
